import { Dispatch, SetStateAction } from 'react';
import { Switch as HeadSwitch } from '@headlessui/react';

export const Switch = ({
  rightLabel,
  enabled,
  setEnabled,
  type,
  leftLabel
}: {
  rightLabel: string;
  enabled: boolean;
  setEnabled: Dispatch<SetStateAction<boolean>>;
  type: string;
  leftLabel?: string;
}) => {
  return (
    <div className="flex items-center pl-4">
      {type === 'two-labels' && (
        <span
          className={`${
            enabled ? 'font-normal text-[#364152]' : 'text-[#2497B2] font-semibold'
          } text-xs font-montserrat capitalize mr-2`}>
          {leftLabel}
        </span>
      )}
      <HeadSwitch
        checked={enabled}
        onChange={setEnabled}
        className={`${
          type === 'two-labels'
            ? 'bg-[#2497B2]'
            : enabled
            ? 'bg-[#7ED7DE] hecked_toggle--border'
            : 'bg-[#E3E8EF] unchecked_toggle--border_reports'
        } 
        ${
          type === 'two-labels'
            ? 'h-[18px] w-[50px]'
            : type === 'one-label-notification'
            ? 'h-[15px] w-[30px]'
            : 'h-[15px] w-[30px]'
        }
          relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}>
        <span
          aria-hidden="true"
          className={`${
            enabled
              ? type === 'one-label-notification'
                ? 'translate-x-3'
                : 'translate-x-[13px] border-[#2497B2] border-[1px] border-solid'
              : type === 'one-label'
              ? 'translate-x-0 border-[1px] border-[#2497B2] border-solid'
              : 'translate-x-0'
          } ${
            type === 'two-labels'
              ? 'h-[14px] w-[30px]'
              : type === 'one-label-notification'
              ? 'h-[11px] w-[14px]'
              : 'h-[13px] w-[14px] -mt-[0.5px]'
          }
            pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </HeadSwitch>
      <span
        className={`${
          type === 'two-labels'
            ? !enabled
              ? 'font-normal text-[#364152]'
              : 'text-[#2497B2] font-semibold'
            : type === 'one-label-notification'
            ? 'text-[#364152]'
            : !enabled
            ? 'font-normal text-[#364152]'
            : 'text-[#364152] font-semibold'
        } text-xs font-montserrat capitalize ml-2`}>
        {rightLabel}
      </span>
    </div>
  );
};
